import clsx from 'clsx'

import s from './styles.module.scss'

interface Props {
  title: string
}

export const RoomTitle = ({ title }: Props) => {
  return (
    <div className={s.wrapper}>
      <h2 className={clsx(s.title, 'extra-bold-18')}>{title}</h2>
    </div>
  )
}
